import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { getRequest, postRequest, deleteRequest } from 'utils/http'

//Get Communities
export const getCommunities = async (current, pageSize, searchQuery) => {
  return getRequest('communities', {
    params: {
      current: current,
      pageSize: pageSize,
      searchQuery: searchQuery,
    },
  })
}

export const useGetCommunities = (current, pageSize, searchQuery) => {
  return useQuery({
    queryKey: ['fetch-communities', current, pageSize, searchQuery],
    queryFn: () => getCommunities(current, pageSize, searchQuery),
  })
}

//Create Community
export const createCommunity = async params => {
  return postRequest(`communities`, params)
}

export const useCreateCommunity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: params => createCommunity(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-communities'])
    },
  })
}

//Update Community
export const updateCommunity = async params => {
  // Use postRequest with the _method: 'PUT' field for file uploads
  return postRequest(`communities/${params.id}`, params.updatedCommunityData)
}

export const useUpdateCommunity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: params => updateCommunity(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-communities'])
    },
  })
}

// Delete Community
export const deleteCommunity = async id => {
  return deleteRequest(`communities/${id}`)
}

export const useDeleteCommunity = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ids => {
      const id = ids[0]
      return deleteCommunity(id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch-communities'])
    },
  })
}
